export const LOCALE_PREFIX = 'scenes.Gnosus.components.EntityHeader'
